<div fxLayout="row" style="width: 100%;">
    <div fxFlex="75" fxLayoutAlign="end center" style="padding-right: 20px;">
        <button (click)="addRow()" mat-flat-button>Προσθήκη γραμμής</button>
        <button (click)="showTemplates()" mat-flat-button>Επιλέξτε από τα πρότυπα</button>
        <button (click)="showSettings()" mat-icon-button matTooltip="Ρυθμίσεις φόρμας">
            <mat-icon style="color: gray;">settings</mat-icon>
        </button>
        <button (click)="toggleBorders()" mat-icon-button matTooltip="Προεπισκόπηση">
            <mat-icon [ngStyle]="!displayBorders && {'color': 'green'}">visibility_eye</mat-icon>
        </button>


      <button (click)="createTemplate()" mat-icon-button matTooltip="Δημιουργία προτύπου">
        <mat-icon style="color: var(--secondaryBlue)">description</mat-icon>
      </button>
<!--        <button (click)="showHelp()" mat-icon-button matTooltip="Αποθήκευση">-->
<!--            <mat-icon>help</mat-icon>-->
<!--        </button>-->
      <div fxLayout="row" fxLayoutAlign="start center" *ngIf="isTemplateNameFieldShown">
        <mat-form-field>
          <mat-label>
            Όνομα προτύπου
          </mat-label>
          <input matInput [(ngModel)]="templateName" [disabled]="isTemplateSaving">
        </mat-form-field>

        <button [disabled]="isTemplateSaving" (click)="saveTemplate()" mat-icon-button matTooltip="Δημιουργία προτύπου">
          <mat-icon style="color: green">save</mat-icon>
        </button>
        <button [disabled]="isTemplateSaving" (click)="cancelTemplateSaving()" mat-icon-button matTooltip="Ακύρωση δημιουργίας προτύπου">
          <mat-icon style="color: red">cancel</mat-icon>
        </button>
      </div>

      <button *ngIf="formOptions.mode === 'create'" (click)="save()" [class.spinner]="isLoading" [disabled]="isLoading" mat-icon-button matTooltip="Αποθήκευση">
        <mat-icon style="color: green">save</mat-icon>
      </button>

        <button *ngIf="formOptions.mode === 'edit'" (click)="update()" [class.spinner]="isLoading" [disabled]="isLoading" mat-icon-button matTooltip="Ενημέρωση">
            <mat-icon style="color: green">update</mat-icon>
        </button>
    </div>
</div>

<ng-container *ngIf="pageLoading then ShowLoading else ShowEditor"></ng-container>
<ng-template #ShowLoading>
    <div fxLayout="column" style="height: 80vh;" fxLayoutAlign="center center">
        <label>Παρακαλούμε περιμένετε όσο φορτώνουμε τη φόρμα...</label>
        <app-loading></app-loading>
    </div>
</ng-template>
<ng-template #ShowEditor>
<div cdkDropListGroup fxLayout="row" style="padding: 15px; width: 100%; background-color: white;" fxLayoutGap="15px">

    <div [fxFlex]="!displayBorders ? 65 : 100" fxLayout="column"
         style="background-color: white; height: 80vh; overflow-y: auto; overflow-x: hidden; padding-bottom: 20px;"
         [fxLayoutGap]="form.settings.gapRow">
        <div fxLayout="row" style="width: 100%; cursor:pointer; margin-bottom: 15px; padding-right: 15px;" [fxLayoutAlign]="form.settings.language.position" *ngIf="form.settings.language.multi">
            <div fxLayoutGap="5px">
                <span  *ngFor="let language of form.settings.language.languages" [ngStyle]="language.id === form.settings.language.preview && {'font-weight': 'bold'}" (click)="setPreviewLanguage(language.id)">{{language.value}}</span>
            </div>
        </div>
        <div *ngFor="let row of rows let rowIndex=index;" fxLayout='row' class="container" [ngClass]="isRowSelected(rowIndex) ? 'container selectedRow' : 'container'">

            <div class="overlay" *ngIf="!isDragging" fxLayoutAlign="start center center">
                <button [disabled]="shouldDisableUpButton(row)" mat-icon-button class="setting-button"
                        (click)="moveUp(row)" matTooltip="Μετακίνηση γραμμής πάνω">
                    <mat-icon class="internal-icons">arrow_circle_up</mat-icon>
                </button>
                <button [disabled]="shouldDisableDownButton(row)" mat-icon-button class="setting-button"
                        (click)="moveDown(row)" matTooltip="Μετακίνηση γραμμής κάτω">
                    <mat-icon class="internal-icons">arrow_circle_down</mat-icon>
                </button>
                <button mat-icon-button class="setting-button" (click)="duplicateRow(row, rowIndex)" matTooltip="Διπλότυπο">
                    <mat-icon class="internal-icons">content_copy</mat-icon>
                </button>
                <button mat-icon-button class="setting-button" (click)="editRow(row)" matTooltip="Ρυθμίσεις">
                    <mat-icon class="internal-icons">settings</mat-icon>
                </button>
                <button mat-icon-button class="setting-button" (click)="deleteRow(rowIndex)"
                        matTooltip="Διαγραφή γραμμής">
                    <mat-icon class="internal-icons" style="color: red">delete</mat-icon>
                </button>

                <mat-checkbox *ngIf="linking.isLinkRowMode" [disabled]="isCheckDisabled(rowIndex)" [checked]="isChecked(rowIndex)" (change)="checkedChange($event, rowIndex)"></mat-checkbox>

            </div>

            <div fxLayout="column" fxLayoutGap="15px;" fxFlex="100">

                <div fxLayout="row" [ngStyle]="{'margin-bottom': row.title.margin}">
                    <label [style.color]="row.title.color">{{displayRowName(row)}}</label>
                </div>

                <div fxLayout="row" [fxLayoutGap]='form.settings.gap' fxFlex="100">
                    <div fxLayout="column" *ngFor="let member of row.members; let i=index" class="internal-container"
                         [fxFlex]="calculateFlex(row.members.length)">
                        <div
                                cdkDropList
                                [cdkDropListData]="member.controls"
                                class="example-list"
                                [ngStyle]="displayBorders && {'border': '0'}"
                                [ngClass]="isMemberSelected(rowIndex, i) ? 'example-list selectedMember' : 'example-list'"
                                (cdkDropListDropped)="drop($event, row, member)">
                            <ng-container
                                    *ngIf="member.controls.length === 0 then ShowAddButton else ShowControl"></ng-container>

                            <ng-template #ShowAddButton>
                                <div fxFlex="100" fxLayoutAlign="center center" *ngIf="!displayBorders">
                                    <button mat-icon-button>
                                        <mat-icon>add</mat-icon>
                                    </button>
                                </div>
                            </ng-template>


                            <ng-template #ShowControl>
                                <div fxLayout="column" fxFlex="100" style="position: relative;"
                                     (click)="editMember(member, rowIndex, i)">

                                    <div class="internal-overlay" *ngIf="!isDragging">
                                        <div *ngIf="member.controls.length >0">
                                            <button mat-icon-button class="setting-button" (click)="editMember(member, rowIndex, i)"
                                                    matTooltip="Ρυθμίσεις πεδίου">
                                                <mat-icon class="internal-icons">edit</mat-icon>
                                            </button>
                                        </div>
                                        <div *ngIf="member.controls.length >0">
                                            <button mat-icon-button class="setting-button"
                                                    (click)="removeMember(member)"
                                                    matTooltip="Αφαίρεση πεδίου">
                                                <mat-icon class="internal-icons">backspace</mat-icon>
                                            </button>
                                        </div>
                                    </div>

                                    <!--#region Input Text-->
                                    <template *ngIf="member.controls[0].type === 'text'" fxLayout="column">
                                        <div fxLayout="row" *ngIf="!member.isLabelHidden"><label class="control-title" [style.color]="member.labelColor ? member.labelColor : '#000000'">{{displayFieldName(member)}}</label>&nbsp;<label *ngIf="member.isRequired">*</label></div>
                                        <mat-form-field fxFlex="100" class="full-width no-padding" appearance="outline">
                                            <input style="width: 100%;" matInput [(ngModel)]="member.value" [placeholder]="displayPlaceHolder(member)">
                                        </mat-form-field>
                                    </template>
                                    <!--#endregion-->
                                    <!--#region Date Text-->
                                    <template *ngIf="member.controls[0].type === 'date'" fxLayout="column">
                                        <div fxLayout="row" *ngIf="!member.isLabelHidden"><label class="control-title" [style.color]="member.labelColor ? member.labelColor : '#000000'">{{displayFieldName(member)}}</label>&nbsp;<label *ngIf="member.isRequired">*</label></div>
                                        <mat-form-field fxFlex="100" class="full-width no-padding" appearance="outline">
                                            <input style="width: 100%;" matInput [matDatepicker]="picker"
                                                   [placeholder]="displayPlaceHolder(member)" [(ngModel)]="member.value">
                                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                            <mat-datepicker #picker></mat-datepicker>
                                        </mat-form-field>
                                    </template>
                                    <!--#endregion-->

                                    <!--#region Textarea-->
                                    <template *ngIf="member.controls[0].type === 'textarea'" fxLayout="column">
                                        <div fxLayout="row" *ngIf="!member.isLabelHidden"><label class="control-title" [style.color]="member.labelColor ? member.labelColor : '#000000'">{{displayFieldName(member)}}</label>&nbsp;<label *ngIf="member.isRequired">*</label></div>
                                        <mat-form-field fxFlex="100" appearance="outline" style="width: 100%;" class="full-width no-padding">
                                            <textarea style="width: 100%;" matInput [placeholder]="displayPlaceHolder(member)"
                                                      [(ngModel)]="member.value"></textarea>
                                        </mat-form-field>
                                    </template>
                                    <!--#endregion-->

                                    <!--#region Dropdown-->
                                    <template *ngIf="member.controls[0].type === 'dropdown'" fxLayout="column">
                                        <div fxLayout="row" *ngIf="!member.isLabelHidden"><label class="control-title" [style.color]="member.labelColor ? member.labelColor : '#000000'">{{displayFieldName(member)}}</label>&nbsp;<label *ngIf="member.isRequired">*</label></div>
                                        <mat-form-field fxFlex="100" appearance="outline" style="width:100%;" class="full-width no-padding">
                                            <mat-select [(ngModel)]="member.value" fxFlex="100" [placeholder]="displayPlaceHolder(member)">
                                                <mat-option *ngFor="let option of member.options"
                                                            [value]="option">{{option.value}}</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </template>
                                    <!--#endregion-->

                                  <!--#region conditional-selector-->
                                  <template *ngIf="member.controls[0].type === 'conditional-selector'" fxLayout="column">
                                    <div fxLayout="row" *ngIf="!member.isLabelHidden"><label class="control-title" [style.color]="member.labelColor ? member.labelColor : '#000000'">{{displayFieldName(member)}}</label>&nbsp;<label *ngIf="member.isRequired">*</label></div>
                                    <mat-form-field fxFlex="100" appearance="outline" style="width:100%;" class="full-width no-padding">
                                      <mat-select [(ngModel)]="member.value" fxFlex="100" [placeholder]="displayPlaceHolder(member)">
                                        <mat-option *ngFor="let option of member.options"
                                                    [value]="option">{{option.value}}</mat-option>
                                      </mat-select>
                                    </mat-form-field>
                                  </template>
                                  <!--#endregion-->

                                    <!--#region Radio-->
                                    <template *ngIf="member.controls[0].type === 'radio'" fxLayout="column">
                                        <div fxLayout="row" *ngIf="!member.isLabelHidden"><label class="control-title" [style.color]="member.labelColor ? member.labelColor : '#000000'">{{displayFieldName(member)}}</label>&nbsp;<label *ngIf="member.isRequired">*</label></div>
                                        <mat-radio-group *ngIf="member.options.length > 0" [(ngModel)]="member.value" fxFlex="100" fxLayoutGap="15px">
                                            <mat-radio-button *ngFor="let option of member.options"
                                                              class="radio"
                                                              [value]="option">{{option.value}}</mat-radio-button>
                                        </mat-radio-group>
                                      <label *ngIf="member.options.length === 0">Προσθέστε επιλογές από τη μορφοποίση του πεδίου</label>
                                    </template>
                                    <!--#endregion-->

                                    <!--#region Image-->
                                    <template *ngIf="member.controls[0].type === 'image'" fxLayout="column">
                                        <img *ngIf="member.value" [src]="member.value" alt="temp"/>
                                      <label *ngIf="!member.value">Προσθέστε το σύνδεσμο της εικόνας από τη μορφοποίση του πεδίου</label>
                                    </template>
                                    <!--#endregion-->

                                    <!--#region File-->
                                    <template *ngIf="member.controls[0].type === 'file'" fxLayout="column">
                                        <div fxLayout="row" *ngIf="!member.isLabelHidden"><label class="control-title" [style.color]="member.labelColor ? member.labelColor : '#000000'">{{displayFieldName(member)}}</label>&nbsp;<label *ngIf="member.isRequired">*</label></div>
                                        <button mat-raised-button (click)="inputField.click();">Επιλέξτε αρχείο</button>
                                        <input type="file" #inputField style="display:none">
                                    </template>
                                    <!--#endregion-->

                                    <!--#region Label-->
                                    <template *ngIf="member.controls[0].type === 'label'" fxLayout="column">
                                        <div fxFlex="100" *ngIf="member.value">
                                            <app-extreme-editor fxFlex="100" [value]="displayValueLabel(member)"
                                                                [isEdit]="false"></app-extreme-editor>
                                        </div>
                                      <div fxFlex="100" fxLayout="row" *ngIf="!member.value" fxLayoutAlign="start center">
                                        <label>Πληκτρολογήστε το κείμενό σας από τη μορφοποίηση του πεδίου</label>
                                      </div>
                                    </template>
                                    <!--#endregion-->

                                  <!--#region Label-->
                                  <template *ngIf="member.controls[0].type === 'checkbox'" fxLayout="column">
                                    <div fxFlex="100" fxLayoutAlign="start center">
                                      <mat-checkbox
                                                    [checked]="member.value">
                                          <div fxLayout="row" *ngIf="!member.isLabelHidden"><label class="control-title" [style.color]="member.labelColor ? member.labelColor : '#000000'">{{displayFieldName(member)}}</label>&nbsp;<label *ngIf="member.isRequired">*</label></div>
                                        <label *ngIf="!member.label">Πληκτρολογήστε το μήνυμα που θα εμφανίζεται από τη μορφοποίηση του πεδίου</label>

                                      </mat-checkbox>
                                    </div>
                                  </template>
                                  <!--#endregion-->
                                </div>

                            </ng-template>

                        </div>

                    </div>

                </div>
            </div>

        </div>
        <div style="height: 50px"></div>
        <div #endForm style="display:hidden"></div>
    </div>

    <!--#region Right Side-->
    <div *ngIf="!displayBorders" fxFlex="35" fxLayout="column">
        <mat-tab-group #tabs mat-stretch-tabs>
            <mat-tab>
                <ng-template mat-tab-label>
                    <div fxLayout="row" style="font-family: 'Century Gothic', sans-serif">
                        Πεδία
                    </div>
                </ng-template>
                <div
                        id="types"
                        style="max-height: 90vh; overflow-y: auto; border: 0!important;"
                        cdkDropList
                        [cdkDropListData]="types"
                        class="example-list"
                        fxLayout="row wrap"
                        fxLayoutAlign="space-evenly"
                >
                    <div class="control-card" *ngFor="let type of types" cdkDrag (cdkDragStarted)="dragStarted()"
                         (cdkDragEnded)="dragEnded()" fxLayout="column" fxLayoutGap="5px">


                        <div fxLayout="row">
                            <mat-icon *ngIf="type.type === 'text'">
                                edit
                            </mat-icon>

                          <mat-icon *ngIf="type.type === 'conditional-selector'">
                            share
                          </mat-icon>

                            <mat-icon *ngIf="type.type === 'checkbox'">
                                check
                            </mat-icon>

                            <mat-icon *ngIf="type.type === 'label'">
                                title
                            </mat-icon>

                            <mat-icon *ngIf="type.type === 'date'">
                                edit_calendar
                            </mat-icon>

                            <mat-icon *ngIf="type.type === 'textarea'">
                                crop_3_2
                            </mat-icon>

                            <mat-icon *ngIf="type.type === 'image'">
                                image
                            </mat-icon>

                            <mat-icon *ngIf="type.type === 'file'">
                                upload_file
                            </mat-icon>

                            <mat-icon *ngIf="type.type === 'radio'">
                                radio_button_unchecked
                            </mat-icon>

                            <mat-icon *ngIf="type.type === 'dropdown'">
                                checklist
                            </mat-icon>
                        </div>
                      <div fxLayout="row" style="text-align: center; font-family: 'Century Gothic'">
                        {{type.name}}
                      </div>
                    </div>
                </div>
            </mat-tab>
            <mat-tab [disabled]="!pageLoaded">
                <ng-template mat-tab-label>
                    <div fxLayout="row" style="font-family: 'Century Gothic', sans-serif">
                        Ρυθμίσεις
                    </div>
                </ng-template>
                <app-resumes-editor-settings *ngIf="pageLoaded" [data]="selectedData" (startLinking)="startLinking($event)"
                                             (closeEvent)="closeEvent($event)"></app-resumes-editor-settings>
            </mat-tab>
        </mat-tab-group>
    </div>


    <!--#endregion-->
</div>
</ng-template>
